export const LOGO_MAX_BYTES = 524288;

export const LOGO_ACCEPTED_TYPES: readonly string[] = ['image/png', 'image/jpeg', 'image/webp'];
